import { useCartContext } from './index';

function Cell({ T, align = 'left', last = false, children, style = {} }) {
    return (
        <div
            style={{
                padding: '0 10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start',
                borderRight: last ? 'none' : `1px solid ${T.line}`,
                minHeight: T.rowH,
                overflow: 'hidden',
                ...style,
            }}
        >
            {children}
        </div>
    );
}

export function CartItemsTable() {
    const { items, T, CART_GRID_COLS, onQtyChange, onRemove } = useCartContext();
    return (
        <div style={{ maxHeight: 420, overflowY: 'auto' }}>
            {items.map((item, i) => (
                <div
                    key={item.row.sku}
                    style={{
                        display: 'grid',
                        gridTemplateColumns: CART_GRID_COLS,
                        background: i % 2 === 0 ? T.bg : T.bgSoft,
                        borderBottom: `1px solid ${T.line}`,
                        minHeight: T.rowH,
                    }}
                >
                    <Cell T={T}>
                        <div style={{ minWidth: 0, width: '100%' }}>
                            <div
                                style={{
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: T.ink,
                                    textTransform: 'uppercase',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    lineHeight: 1.3,
                                }}
                                title={item.row.name}
                            >
                                {item.row.name}
                            </div>
                            <div style={{ fontSize: 11, color: T.muted, fontFamily: T.mono, marginTop: 2 }}>
                                {item.row.sku}
                            </div>
                        </div>
                    </Cell>

                    <Cell T={T} align="right">
                        <span style={{ fontFamily: T.mono, fontSize: 12, color: T.inkMid }}>{item.row.bling || 0}</span>
                    </Cell>

                    <Cell T={T} align="right">
                        <span style={{ fontFamily: T.mono, fontSize: 12, color: T.inkMid, whiteSpace: 'nowrap' }}>
                            R${' '}
                            {Number(item.row.cost || 0)
                                .toFixed(2)
                                .replace('.', ',')}
                        </span>
                    </Cell>

                    <Cell T={T} align="center">
                        <input
                            type="number"
                            value={item.qty}
                            min={1}
                            max={999999}
                            onChange={(e) => {
                                let v = Number.parseInt(e.target.value, 10);
                                if (!Number.isFinite(v) || v <= 0) return;
                                // Clamp também ao DIGITAR (não só nas setas
                                // de incremento). Limite 999.999 cobre SKUs
                                // de alto giro (ex: ENVELOPECOPA2026 ~839k).
                                if (v > 999999) v = 999999;
                                onQtyChange(item.row.sku, v);
                            }}
                            style={{
                                width: 56,
                                height: 28,
                                textAlign: 'center',
                                border: `1px solid ${T.line}`,
                                borderRadius: 4,
                                fontFamily: T.mono,
                                fontSize: 13,
                                color: T.ink,
                                background: T.bg,
                                outline: 'none',
                            }}
                        />
                    </Cell>

                    <Cell T={T} align="right">
                        <span
                            style={{
                                fontFamily: T.mono,
                                fontSize: 13,
                                fontWeight: 600,
                                color: T.ink,
                                whiteSpace: 'nowrap',
                            }}
                        >
                            R${' '}
                            {(item.qty * (item.row.cost || 0)).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                            })}
                        </span>
                    </Cell>

                    <Cell T={T} align="center" last>
                        <button
                            type="button"
                            onClick={() => onRemove(item.row.sku)}
                            title="Remover"
                            style={{
                                width: 24,
                                height: 24,
                                border: 'none',
                                background: 'transparent',
                                cursor: 'pointer',
                                color: T.muted,
                                fontSize: 16,
                                display: 'grid',
                                placeItems: 'center',
                                borderRadius: 4,
                            }}
                        >
                            ×
                        </button>
                    </Cell>
                </div>
            ))}
        </div>
    );
}
